import _ from "lodash";
import moment from "moment";
import PropTypes from "prop-types";
import { CSVLink } from "react-csv";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import ReactTable, { ReactTableDefaults } from "react-table";
import Button from "../../../../core/modules/common/components/Button";
import ButtonTabs from "../../../../core/modules/common/components/ButtonTabs";
import Icons from "../../../../core/modules/common/components/Icons";
import downloadReportAsXlsx from "../excel/downloadReport";
import MasterDetailsReport from "./MasterDetailsReport";
import ChartModal from "../../../../core/modules/common/components/ChartModal";
import ReportsNavigationButtonTabs from "./ReportsNavigationButtonTabs";
import XlsExportModal from "./XlsExportModal";
import XlsExportLoadingModal from "./XlsExportLoadingModal";
import LegendModal from "./LegendModal";
import EpgLegendModal from "./EpgLegendModal";
import OnScreenModal from "./OnScreenModal";
import ColorLegendModal from "./ColorLegendModal";
import SaveReportModal from "./SaveReportModal";
import ReportCustomFilters from "./ReportCustomFiltersContainer";
import { sortValues } from "../../../react-table/helpers/sortValues";
import {
  getCurrentReport,
  getRequestParams,
  getUserType,
} from "../../../user/redux/selectors/UserReportSelectors";
import { saveUserReportRequestActionCreator } from "../../../user/redux/actions/UserActions";
import {
  getAsyncReq,
  getIsAsync,
  getIsSync,
  getReportFiltering,
  getReportSorting,
  getResponseMode,
} from "../redux/selectors/ReportsSelectors";
import { getSelectionCriteria } from "../../../wizard/common/redux/selectors/SelectionCriteriaWizardSelectors";
import ReportDefinitions from "../../../common/config/ReportDefinitions";
import SelectionCriteriaDto from "../models/SelectionCriteriaDto";
import config from "../../../../core/config/configureSettings";
import noop from "../../../../core/modules/common/tools/noop";
import {
  configuredReportList,
  createCsvExportFromTableSelection,
  deepClone,
  getLeafColumns,
} from "../../../react-table/helpers/utils";
import ItemOverviewDetails from "../../item/item-overview/details/containers/ItemOverviewDetails200Columns";
import { replaceDotsWithDashes } from "../excel/excelTemplatePopulator";
import WarningAsyncReportModal from "../../../common/components/WarningAsyncReportModal";
import LegendModalThresholdsForCertification from "./LegendModalThresholdsForCertification";
import fieldFormatter from "../../../react-table/helpers/fieldFormatter";

Object.assign(ReactTableDefaults, {
  defaultSortMethod: sortValues,
});

const CLIPBOARD_STATE_RED = "rgba(255,5,12,0.49)";
const CLIPBOARD_STATE_YELLOW = "rgba(255,252,56,0.99)";
const CLIPBOARD_STATE_GREEN = "rgba(170,255,169,1)";
const TABLE_COLUMN_SELECTION_COLOR = "rgba(255,215,0,0.31)";
const TABLE_CELL_SELECTION_COLOR = "rgba(170,255,169,0.31)";

const paginationMapper = [];
export class Report extends Component {
  constructor(props) {
    super(props);
    this.openModal = this.openModal.bind(this);
    this.openXlsExcelLoading = this.openXlsExcelLoading.bind(this);
    this.changePage = this.changePage.bind(this);
    this.openChartModal = this.openChartModal.bind(this);
    this.openLegendModal = this.openLegendModal.bind(this);
    this.openLegendThresholdsForCertification =
      this.openLegendThresholdsForCertification.bind(this);
    this.openLegend = this.openLegend.bind(this);
    this.openColorLegend = this.openColorLegend.bind(this);
    this.exportPdf = this.exportPdf.bind(this);
    this.state = {
      page: 0,
      showModal: false,
      showLoadingModal: false,
      showChartModal: false,
      showLabelModal: false,
      showLegendEpgModal: false,
      showLegendThresholdsForCertification: false,
      showColorLegend: false,
      showOnScreenModal: true,
      showSaveReportModal: false,
      showWarningAsyncReport: false,
      headerTitle: false,
      epgTitle: "",
      expanded: {},
      sortedData: [],
      sortingEnabled: true,
      filteringEnabled: true,
      excelDisabled: false,
      maxRow: 50000,
      clipboard: {
        clipboardEnabled: false,
        clipboardState: CLIPBOARD_STATE_RED,
        clipboardButtonStyle: {
          backgroundColor: CLIPBOARD_STATE_RED,
        },
        th: [],
        tr: [],
        td: [],
      },
    };
  }

  componentDidUpdate(nextProps) {
    if (this.state.clipboard.clipboardEnabled) {
      document.addEventListener("keydown", this.handleKeyDown);
    }
    const { perReportConfiguration } = config;
    if (nextProps.data !== this.props.data) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ sortedData: this.props.data || [] });
      const configuredReports = configuredReportList(perReportConfiguration);
      const defaultMaxRow = config.maxRowsForExcelExport;
      if (
        configuredReports.filter(
          (a) =>
            a.reportId === this.props.reportId &&
            this.props.data.length > a.maxSize
        ).length !== 0
      ) {
        const eachReport = configuredReports.filter(
          (a) =>
            a.reportId === this.props.reportId &&
            this.props.data.length > a.maxSize
        );
        this.setState({
          excelDisabled: true,
          maxRow: eachReport[0].maxSize,
        });
      } else if (this.props.data.length > defaultMaxRow) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          excelDisabled: true,
          maxRow: defaultMaxRow,
        });
      }
    }

    if (
      nextProps.responseMode !== this.props.responseMode &&
      this.props.responseMode !== undefined &&
      this.props.responseMode === "AUTO_SWITCHED_ASYNC"
    ) {
      this.setState({
        showWarningAsyncReport: true,
      });
    }
  }

  componentWillUnmount() {
    if (this.state.clipboard.clipboardEnabled) {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }

  onFilteredChange = (column, value) => {
    this.setState({
      sortedData: this.reactTableElement.getResolvedState().sortedData,
    });
    this.changePage(0);
    this.collapseAll();

    if (this.props.onFilteredChange && this.props.onFilteredChange !== noop) {
      this.props.onFilteredChange.apply(null, [column, value]);
    }
  };

  onSortedChange = (newSorted, column, shiftKey) => {
    if (this.props.onSortedChange && this.props.onSortedChange !== noop) {
      this.props.onSortedChange.apply(null, [newSorted, column, shiftKey]);
    }
  };

  reactTableRef = (ELEMENT_REF) => {
    this.reactTableElement = ELEMENT_REF;
  };

  collapseAll = () => this.setState({ expanded: {} });

  // eslint-disable-next-line arrow-body-style
  formatData = (data, columns, footerData) => {
    const tableFormatedData = _.map(data, (row) =>
      _.reduce(
        columns,
        (acc, column) => {
          // Use excelFormatter if available, fallback to column.type for backwards compatibility
          const formatterName = column.excelFormatter || column.type;
          const formatFunction = formatterName
            ? fieldFormatter(formatterName)
            : null;
          const value = row[column.id];

          return {
            ...acc,
            [column.id]: formatFunction ? formatFunction({ value }) : value,
          };
        },
        row
      )
    );

    return footerData ? [footerData, ...tableFormatedData] : tableFormatedData;
  };

  formatDataForPredes = (data, columns, footerData) => {
    const formattedDataPredes = _.map(data, (row) =>
      _.reduce(
        columns,
        (acc, column) => {
          const formatterName = column.excelFormatter || column.type;
          const formatFunction = formatterName
            ? fieldFormatter(formatterName)
            : null;
          let value = row[column.id];
          if (value === 0 || value === null || value === "0") {
            value = "";
          }
          if (column.type === "number" && !value) {
            value = 0;
          }
          return {
            ...acc,
            [column.id]: formatFunction ? formatFunction({ value }) : value,
          };
        },
        row
      )
    );

    return footerData
      ? [footerData, ...formattedDataPredes]
      : formattedDataPredes;
  };

  downloadReport = () => {
    const { excelDisabled } = this.state;

    this.setState({
      showModal: false,
    });

    const report = ReportDefinitions[this.props.reportId];
    const selectionCriteria = new SelectionCriteriaDto(
      this.props.selectionCriteria,
      report.selectionCriteria.items,
      true
    );

    let reportData;
    if (this.reactTableElement) {
      reportData = this.reactTableElement.getResolvedState();
    } else {
      reportData = this.prepareData(this.props.data);
    }
    const list = document.getElementsByClassName("rt-tfoot");
    const totalRowData = [];
    const totalRow = {};
    // bunu queryselector ile bak
    if (list[0]) {
      const colList = reportData.allVisibleColumns.map((a) =>
        replaceDotsWithDashes(a.id)
      );

      const totalRowTFootData = list[0].children[0].children;
      // eslint-disable-next-line no-restricted-syntax
      for (const item of totalRowTFootData) {
        totalRowData.push(item.innerText.replace("%", ""));
      }
      // eslint-disable-next-line no-return-assign
      colList.forEach((col, i) => (totalRow[col] = totalRowData[i]));
    }
    const reportMetadata = {
      reportName: this.props.currentReport.topLevelName,
      reportCode: this.props.reportId,
      reportMode: this.props.mode,
      generatedOnDateTime: this.props.generatedOnDateTime,
    };
    if (!excelDisabled) {
      if (this.props.reportId === "ITEM_OVERVIEW_DETAILS_200") {
        downloadReportAsXlsx(
          reportData,
          null,
          reportMetadata,
          selectionCriteria
        );
      } else if (reportData.sortedData.length > 300000) {
        downloadReportAsXlsx(
          reportData.sortedData.slice(0, 300000),
          reportData.allVisibleColumns,
          reportMetadata,
          selectionCriteria,
          totalRow
        );
      } else {
        downloadReportAsXlsx(
          reportData.sortedData,
          reportData.allDecoratedColumns,
          reportMetadata,
          selectionCriteria,
          totalRow
        );
      }
    }
    this.setState({
      showLoadingModal: false,
    });
  };

  // eslint-disable-next-line react/sort-comp
  changePage(pageIndex) {
    this.setState({
      page: pageIndex,
    });
    paginationMapper[this.props.reportId] = pageIndex;
    if (paginationMapper[this.props.reportId] === null) {
      this.setState({
        page: 0,
      });
      paginationMapper[this.props.reportId] = pageIndex;
    } else {
      this.setState({
        page: paginationMapper[this.props.reportId],
      });
    }
  }

  openModal() {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showModal: !this.state.showModal,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  openOnScreenModal() {}

  openXlsExcelLoading() {
    this.setState({
      showLoadingModal: true,
    });
    setTimeout(() => {
      this.downloadReport();
    }, 1000);
  }

  closeXlsExcelLoading() {
    this.setState({
      showLoadingModal: false,
    });
  }

  openLegend() {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showLegendEpgModal: !this.state.showLegendEpgModal,
    });
  }

  openLegendThresholdsForCertification() {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showLegendThresholdsForCertification:
        !this.state.showLegendThresholdsForCertification,
    });
  }

  openColorLegend() {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showColorLegend: !this.state.showColorLegend,
    });
  }

  openLegendModal() {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showLabelModal: !this.state.showLabelModal,
    });
  }

  openChartModal() {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showChartModal: !this.state.showChartModal,
    });
  }

  openSaveReportModal = () => {
    this.setState({
      showSaveReportModal: true,
    });
  };

  closeSaveReportModal = () => {
    this.setState({
      showSaveReportModal: false,
    });
  };

  closeWarningModal = () => {
    this.setState({
      showWarningAsyncReport: false,
    });
  };

  saveReport = ({ selectionName }) => {
    const { reportCode } = this.props.currentReport;
    this.props.saveUserReportRequestActionCreator({
      selectionName,
      reportCode,
      requestBody: JSON.stringify(this.props.requestParams),
    });
    this.closeSaveReportModal();
  };

  openPaperFreeApp = () => {
    const { paperfree } = config.applications;
    window.open(paperfree);
  };

  exportPdf = (
    columns,
    data,
    reportId,
    generatedOnTime,
    filteredData,
    totalRows
  ) => {
    const headerArray = [];
    columns.forEach((element) => {
      const header = element.columns;
      header.forEach((res) => {
        const headerList = [res.Header];
        headerArray.push(headerList);
      });
    });
    const body = [];
    const rows = totalRows.concat(data);
    rows.forEach((element) => {
      // eslint-disable-next-line max-len
      const rowData = [
        element.inboundEpgOperator,
        element.operator,
        element.links,
        parseInt(element.performance, 10),
        element.rank,
      ];
      const concatArray = rowData.concat(element.monthYears);
      body.push(concatArray);
    });
    body[0][3] = rows[0].performance;

    // eslint-disable-next-line global-require
    const jsPDF = require("jspdf");
    // eslint-disable-next-line global-require
    require("jspdf-autotable");
    // eslint-disable-next-line new-cap
    const pdf = new jsPDF("l", "mm", [1000, 780]);
    const content = {
      head: [headerArray],
      body,
      // eslint-disable-next-line object-shorthand
      didParseCell: function (HookData) {
        if (HookData.row.index === 0 && HookData.section !== "head") {
          HookData.cell.styles.fillColor = "#bfbfbf";
        }
        if (
          HookData.cell.text[0] <= 94.9 &&
          HookData.column.index !== 2 &&
          HookData.column.index !== 4 &&
          HookData.row.index !== 0
        ) {
          HookData.cell.styles.fillColor = "#D20020";
          HookData.cell.styles.textColor = "#FFF";
          HookData.cell.styles.fontStyle = "bold";
          HookData.cell.styles.fontSize = "10";
          // eslint-disable-next-line prefer-template
          HookData.cell.text =
            HookData.cell.text[0] === "" ? "" : HookData.cell.text[0] + "%";
          HookData.cell.styles.halign = "right";
        } else if (
          HookData.cell.text[0] >= 95.0 &&
          HookData.cell.text[0] <= 96.9 &&
          HookData.column.index !== 2 &&
          HookData.column.index !== 4 &&
          HookData.row.index !== 0
        ) {
          HookData.cell.styles.fillColor = "#ffac31";
          HookData.cell.styles.textColor = "#FFF";
          HookData.cell.styles.fontStyle = "bold";
          HookData.cell.styles.fontSize = "10";
          // eslint-disable-next-line prefer-template
          HookData.cell.text =
            HookData.cell.text[0] === "" ? "" : HookData.cell.text[0] + "%";
          HookData.cell.styles.halign = "right";
        } else if (
          HookData.cell.text[0] >= 97.0 &&
          HookData.cell.text[0] <= 100.0 &&
          HookData.column.index !== 2 &&
          HookData.column.index !== 4 &&
          HookData.row.index !== 0
        ) {
          HookData.cell.styles.fillColor = "#00AF4F";
          HookData.cell.styles.textColor = "#FFF";
          HookData.cell.styles.fontStyle = "bold";
          HookData.cell.styles.fontSize = "10";
          // eslint-disable-next-line prefer-template
          HookData.cell.text =
            HookData.cell.text[0] === "" ? "" : HookData.cell.text[0] + "%";
          HookData.cell.styles.halign = "right";
        } else if (HookData.column.index === 2 || HookData.column.index === 4) {
          HookData.cell.styles.halign = "right";
        }
      },
      headStyles: {
        fillColor: "#F8F7F6",
        textColor: "#6A6B6B",
      },
      margin: { top: 50 },
    };
    pdf.setFillColor(0, 0, 0);
    pdf.rect(15, 20, pdf.internal.pageSize.getWidth() - 30, 20, "FD");
    pdf.setTextColor("#FFF");
    pdf.text(
      `EPG - RESDES SCANNING PERFORMANCE - 13 months ongoing
        EPG Management Summary`,
      pdf.internal.pageSize.getWidth() / 2,
      30,
      null,
      null,
      "center"
    );
    pdf.autoTable(content);
    const { finalY } = pdf.lastAutoTable; // The y position on the page
    pdf.setFillColor("#00AF4F");
    pdf.rect(15, finalY + 10, 30, 8, "FD");
    pdf.setTextColor("#fff");
    pdf.setFontSize(9);
    pdf.text(17, finalY + 15, "97.0% - 100.0%");
    pdf.setFillColor("#ffac31");
    pdf.rect(15, finalY + 18, 30, 8, "FD");
    pdf.setTextColor("#6A6B6B");
    pdf.text(17, finalY + 23, "95.0% - 96.9%");
    pdf.setFillColor("#D20020");
    pdf.rect(15, finalY + 26, 30, 8, "FD");
    pdf.setTextColor("#fff");
    pdf.text(17, finalY + 31, "0.0% - 94.9%");
    pdf.save(`${reportId}_${generatedOnTime.substring(0, 16)}.pdf`);
  };

  enableClipboard = () => {
    const leafColumns = getLeafColumns(this.props.columns);
    const newState = {
      ...this.state,
      sortingEnabled: false,
      filteringEnabled: false,
      clipboard: {
        clipboardEnabled: true,
        clipboardState: CLIPBOARD_STATE_YELLOW,
        clipboardButtonStyle: {
          backgroundColor: CLIPBOARD_STATE_YELLOW,
        },
        th: leafColumns.map((column) => column.accessor),
        tr: [],
        td: [],
      },
    };
    this.setState(newState);
  };

  disableClipboard = () => {
    const newState = {
      ...this.state,
      sortingEnabled: true,
      filteringEnabled: true,
      clipboard: {
        clipboardEnabled: false,
        clipboardState: CLIPBOARD_STATE_RED,
        clipboardButtonStyle: {
          backgroundColor: CLIPBOARD_STATE_RED,
        },
        th: [],
        tr: [],
        td: [],
      },
    };
    this.setState(newState);
  };

  handleColumnSelection = (columnSelectionEvent, column) => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    let newClipboardState = { ...this.state.clipboard };
    const thWithSameColumnId = newClipboardState.th.find(
      (th) => th === column.id
    );
    if (thWithSameColumnId) {
      newClipboardState.th.splice(
        newClipboardState.th.indexOf(thWithSameColumnId),
        1
      );
    } else {
      newClipboardState.th.push(column.id);
    }

    if (newClipboardState.th.length === 0) {
      newClipboardState.tr = [];
    }

    const leafColumns = getLeafColumns(this.props.columns);
    newClipboardState.th.sort((th1, th2) => {
      // eslint-disable-next-line no-shadow
      const columnTh1 = leafColumns.find((column) => column.accessor === th1);
      // eslint-disable-next-line no-shadow
      const columnTh2 = leafColumns.find((column) => column.accessor === th2);
      // const indexTh1 = leafColumns.indexOf(columnTh1);
      // const indexTh2 = leafColumns.indexOf(columnTh2);
      return leafColumns.indexOf(columnTh1) > leafColumns.indexOf(columnTh2);
    });

    newClipboardState = {
      ...newClipboardState,
      clipboardState:
        newClipboardState.tr.length > 0
          ? CLIPBOARD_STATE_GREEN
          : CLIPBOARD_STATE_YELLOW,
      clipboardButtonStyle: {
        backgroundColor:
          newClipboardState.tr.length > 0
            ? CLIPBOARD_STATE_GREEN
            : CLIPBOARD_STATE_YELLOW,
      },
    };

    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      ...this.state,
      clipboard: newClipboardState,
    });
  };

  handleCellSelection = (cellSelectionEvent, rowInfo) => {
    if (!this.isColumnSelectionExists) {
      return;
    }
    // eslint-disable-next-line react/no-access-state-in-setstate
    let newClipboardState = { ...this.state.clipboard };

    const trWithSameRowIndex =
      newClipboardState.tr.length === 0
        ? -1
        : newClipboardState.tr.find((tr) => tr === rowInfo.index, -1);
    if (
      trWithSameRowIndex !== -1 &&
      typeof trWithSameRowIndex !== "undefined"
    ) {
      if (cellSelectionEvent.shiftKey) {
        const rowsNotSelected = this.props.data
          .filter(
            (row) =>
              !newClipboardState.tr.includes(this.props.data.indexOf(row))
          )
          .map((row) => this.props.data.indexOf(row));

        let closestIndex = -1;
        let distance = this.props.data.length;
        rowsNotSelected.forEach((markedIndex) => {
          const thisDistance = Math.abs(markedIndex - rowInfo.index);
          if (thisDistance < distance) {
            distance = thisDistance;
            closestIndex = markedIndex;
          }
        });

        const rangeStart = Math.min(closestIndex, rowInfo.index);
        const rangeEnd = Math.max(closestIndex, rowInfo.index) + 1;
        _.range(rangeStart, rangeEnd, 1)
          .filter((i) => i !== closestIndex)
          .forEach((i) =>
            newClipboardState.tr.splice(newClipboardState.tr.indexOf(i), 1)
          );
      } else {
        newClipboardState.tr.splice(
          newClipboardState.tr.indexOf(trWithSameRowIndex),
          1
        );
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (cellSelectionEvent.shiftKey) {
        let closestIndex = -1;
        let distance = this.props.data.length;
        newClipboardState.tr.forEach((markedIndex) => {
          const thisDistance = Math.abs(markedIndex - rowInfo.index);
          if (thisDistance < distance) {
            distance = thisDistance;
            closestIndex = markedIndex;
          }
        });

        const rangeStart = Math.min(closestIndex, rowInfo.index);
        const rangeEnd = Math.max(closestIndex, rowInfo.index) + 1;
        _.range(rangeStart, rangeEnd, 1)
          .filter((i) => i !== closestIndex)
          .forEach((i) => newClipboardState.tr.push(i));
      } else {
        newClipboardState.tr.push(rowInfo.index);
      }
    }

    newClipboardState.tr.sort((a, b) => a > b);
    newClipboardState.td = [];
    newClipboardState.tr.forEach((tr) =>
      newClipboardState.th.forEach((th) =>
        newClipboardState.td.push({
          columnId: th,
          rowIndex: tr,
        })
      )
    );

    newClipboardState = {
      ...newClipboardState,
      clipboardState:
        newClipboardState.tr.length > 0
          ? CLIPBOARD_STATE_GREEN
          : CLIPBOARD_STATE_YELLOW,
      clipboardButtonStyle: {
        backgroundColor:
          newClipboardState.tr.length > 0
            ? CLIPBOARD_STATE_GREEN
            : CLIPBOARD_STATE_YELLOW,
      },
    };

    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      ...this.state,
      clipboard: newClipboardState,
    });
  };

  // eslint-disable-next-line arrow-body-style
  isCellSelectionExists = () => {
    return this.isColumnSelectionExists() && this.isRowSelectionExists();
  };

  // eslint-disable-next-line arrow-body-style
  isColumnSelectionExists = () => {
    return (
      this.state.clipboard.clipboardEnabled &&
      this.state.clipboard.td.length > 0
    );
  };

  // eslint-disable-next-line arrow-body-style
  isRowSelectionExists = () => {
    return (
      this.state.clipboard.clipboardEnabled &&
      this.state.clipboard.tr.length > 0
    );
  };

  // eslint-disable-next-line arrow-body-style
  isColumnSelected = (column) => {
    return this.state.clipboard.th.some((th) => th === column.id);
  };

  // eslint-disable-next-line arrow-body-style
  isRowSelected = (rowInfo) => {
    return this.state.clipboard.tr.some((tr) => tr === rowInfo.index);
  };

  // eslint-disable-next-line arrow-body-style
  isCellSelected = (column, rowInfo) => {
    return this.isColumnSelected(column) && this.isRowSelected(rowInfo);
  };

  handleKeyDown = (event) => {
    const charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey && charCode === "c") {
      this.toClipboard(
        event,
        createCsvExportFromTableSelection(
          this.state.clipboard,
          this.props.columns,
          this.props.data
        )
      );
    }

    // For MAC
    if (event.metaKey && charCode === "c") {
      this.toClipboard(
        event,
        createCsvExportFromTableSelection(
          this.state.clipboard,
          this.props.columns,
          this.props.data
        )
      );
    }
  };

  toClipboard = (event, text) => {
    // eslint-disable-next-line no-undef
    if (navigator.clipboard) {
      // eslint-disable-next-line no-undef
      navigator.clipboard.writeText(text);
    } else if (event.clipboardData) {
      event.clipboardData.setData(text);
    } else {
      const textField = document.createElement("textarea");
      textField.innerText = text;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand("copy");
      textField.remove();
    }
  };

  getFooterData = (tableCol, tableData) => {
    return tableCol.reduce((acc, column) => {
      const value =
        typeof column.Footer === "function"
          ? column.Footer({
              data: tableData.sortedData,
              column: column,
            })
          : column.Footer;

      acc[column.id] = value;

      return acc;
    }, {});
  };

  render() {
    const {
      columns,
      totalColumns,
      generatedOnDateTime,
      isLoading,
      masterDetailsReport,
      modeTabs,
      mode,
      changeMode,
      tabs,
      reportId,
      getTrProps,
      className,
      isAsync,
      isSync,
      userType = "",
      tabsForceDataFetch = false,
      isAsyncRequest,
      totalRows,
      prepareData,
    } = this.props;

    let data = prepareData(this.props.data);
    let mainReportId;
    if (tabs) {
      mainReportId = tabs[0].value;
    }
    const { excelDisabled } = this.state;
    if (isLoading) {
      paginationMapper[reportId] = null;
    }
    const hasColumns = !!(columns && columns.length);
    const hasTotalColumns = !!(totalColumns && totalColumns.length);
    const generatedOn = {
      date: moment(generatedOnDateTime).format("DD/MMM/YYYY"),
      time: moment(generatedOnDateTime).format("HH:mm"),
    };
    let csvFileNameData;
    let csvFileNameSC;
    if (generatedOnDateTime) {
      csvFileNameData = `Report ${reportId}_${generatedOnDateTime.substring(
        0,
        16
      )}.csv`;
      csvFileNameSC = `SC ${reportId}_${generatedOnDateTime.substring(
        0,
        16
      )}.csv`;
    }
    let reportData;
    let allCol;
    let labelData;
    let idData;
    let footerData;

    if (this.reactTableElement) {
      reportData = this.reactTableElement.getResolvedState();
      allCol = reportData.allVisibleColumns;
      labelData = allCol.map((x) => x.Header);
      idData = allCol.map((x) => x.id);
      footerData = this.getFooterData(allCol, reportData);
    } else {
      reportData = data;
      allCol = "";
    }

    const { metadata } = this.props.reporting[this.props.reportId];
    const { originalRowCount } = metadata;
    const header = [];
    let headerSC = [];
    let scData = [];
    if (labelData !== undefined && labelData.length > 0) {
      // eslint-disable-next-line no-plusplus
      for (let index = 0; index < labelData.length; index++) {
        if (labelData[index]) {
          header.push({
            label: labelData[index]
              ? labelData[index].replaceAll("\n", " ")
              : labelData[index],
            key: idData[index],
          });
        }
      }
    }
    let formattedData;

    if (
      this.props.currentReport.reportCode ===
        "PREDES_RESDES_DESPATCHES_DETAILS" ||
      this.props.currentReport.reportCode ===
        "PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_SUMMARY" ||
      this.props.currentReport.reportCode ===
        "PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_DETAILS"
    ) {
      // eslint-disable-next-line max-len
      formattedData = this.formatDataForPredes(
        reportData.sortedData,
        reportData.allDecoratedColumns,
        footerData
      );
    } else {
      formattedData = this.formatData(
        reportData.sortedData,
        reportData.allDecoratedColumns,
        footerData
      );
    }
    const csv = (value) => value.join(", ");
    // eslint-disable-next-line prefer-template
    const csvMail = (value) => value.join(", ") + "\n";
    const csvDespatchType = (value) =>
      csvMail(
        (value || [])
          .filter((v) => v.mailSubClasses.length)
          .map((v) => v.mailSubClasses.map((msc) => v.mailCategoryCode + msc))
          .reduce((a, b) => a.concat(b), [])
      );
    const csvTransportMode = (value) =>
      (value || [])
        .filter((v) => v.transportModes.length)
        .map((v) => `${v.legCode}: ${csv(v.transportModes)}`)
        .join(" - ");

    const scValueMapper = {
      period: (value) =>
        value.from === value.to ? value.from : `${value.from} -> ${value.to}`,
      dateField: (value) =>
        value
          .toLowerCase()
          .split("_")
          .map((w) => w[0].toUpperCase() + w.substr(1).toLowerCase())
          .join(" "),
      direction: (value) => (value === "O" ? "Outbound" : "Inbound"),
      mailCategoriesWithSubClasses: csvDespatchType,
      originExchangeOffices: csv,
      destinationExchangeOffices: csv,
      originUnlocodes: csv,
      destinationUnlocodes: csv,
      originMailboxes: csv,
      destinationMailboxes: csv,
      legsWithTransportModes: csvTransportMode,
      carriers: csv,
      handlers: csv,
      excludeEtoes: (value) => value,
      spaceSeparatedItemIds: (value) => value,
      itemsMissingEvents: csv,
      itemsWithEvents: csv,
      spaceSeparatedSuffixes: (value) => value,
      filterOnDespatchTypes: (value) => value,
      filterOnImpcs: (value) => value,
      itemPrefixes: csv,
    };
    const scNameMapper = {
      period: "Period",
      dateField: "Date field",
      direction: "Direction",
      originExchangeOffices: "Origin location",
      destinationExchangeOffices: "Destination location",
      originUnlocodes: "Origin location",
      destinationUnlocodes: "Destination location",
      originMailboxes: "Origin location",
      destinationMailboxes: "Destination location",
      mailCategoriesWithSubClasses: "Despatch type",
      legsWithTransportModes: "Method",
      carriers: "Carrier",
      handlers: "Handler",
      requestMode: "Request Mode",
      excludeEtoes: "Excluded etoes",
      spaceSeparatedItemIds: "Space Separated Items ids",
      itemsMissingEvents: "Missing items",
      itemsWithEvents: "With items",
      spaceSeparatedSuffixes: "Space separated suffixes",
      filterOnDespatchTypes: "Filter on despatch types",
      filterOnImpcs: "Filter on Impcs",
      itemPrefixes: "Item prefixes",
    };

    const report = ReportDefinitions[this.props.reportId];
    const selectionCriteria = new SelectionCriteriaDto(
      this.props.selectionCriteria,
      report.selectionCriteria.items,
      true
    );
    scData = Object.keys(selectionCriteria).map((key) => ({
      name: scNameMapper[key],
      // eslint-disable-next-line no-nested-ternary
      value:
        scValueMapper[key] && selectionCriteria[key]
          ? scValueMapper[key](selectionCriteria[key])
          : typeof selectionCriteria[key] === "boolean"
          ? selectionCriteria[key].toString()
          : selectionCriteria[key],
    }));
    scData.unshift({
      name: "Report Name",
      value: this.props.currentReport.name,
    });
    headerSC = [
      { label: "", key: "name" },
      { label: "", key: "value" },
    ];
    let even;
    let previousId;
    let defaultSorted = this.props.defaultSorted;

    let getTrPropsFunc = getTrProps;
    if (masterDetailsReport) {
      defaultSorted = [{ id: masterDetailsReport.id, desc: false }];
      if (!getTrPropsFunc) {
        getTrPropsFunc = (state, rowInfo) => {
          if (!rowInfo) {
            return {};
          }

          const rowId = _.get(rowInfo.original, masterDetailsReport.id);
          if (rowId && rowId !== previousId) {
            previousId = rowId;
            if (rowInfo.viewIndex === 0) {
              even = false;
            } else {
              even = !even;
            }
          }
          return {
            className: even ? "even-group" : "uneven-group",
          };
        };
      }
    }
    if (!getTrPropsFunc) {
      getTrPropsFunc = () => ({ className: "" });
    }

    const columnsTransformed = deepClone(columns);
    if (!this.state.filteringEnabled) {
      const leafColumns = getLeafColumns(columnsTransformed);
      leafColumns.forEach((column) => {
        column.sortable = false;
        column.filterable = false;
        column.Footer = "";
        column.getFooterProps = () => {};
      });
    }

    return (
      <div className="report-wrapper">
        <h2 className="report-title">
          {this.props.currentReport.topLevelName}
        </h2>
        {isAsync && (
          <div className="report-message">
            Your report request has been successfully submitted. The link to
            download the report will be sent to you at your registered e-mail
            address when the report is ready.
          </div>
        )}
        {isAsyncRequest && !isAsync && (
          <div className="report-message" style={{ textAlign: "center" }}>
            <Icons.Custom name="spinner" className="fa-spin" />
            <span style={{ marginLeft: "10px" }}>Submitting request ...</span>
          </div>
        )}
        {isSync && !isAsyncRequest && (
          <section className={`generated-report ${className}`}>
            <div className="generated-report__header">
              {tabs && (
                <div className="report__button-tabs">
                  <ReportsNavigationButtonTabs
                    tabs={tabs}
                    activeTab={reportId}
                    activePage={this.state.page}
                    forceDataFetch={tabsForceDataFetch}
                  />
                </div>
              )}
              {this.props.showCollapseButton && (
                <div>
                  <Button iconComponent={<Icons.Custom name="bar-chart" />} />
                </div>
              )}
              {this.props.showLegend && (
                <div className="legend-button">
                  <Button
                    text="app.button.legend"
                    onClick={() => this.openLegend()}
                  />
                </div>
              )}
              {this.props.showColorLegend && (
                <div className="legend-button">
                  <Button
                    text="app.button.legend"
                    onClick={() => this.openColorLegend()}
                  />
                </div>
              )}
              {this.props.showLegendEpgModal && (
                <div className="legend-button">
                  <Button
                    text="app.button.legend"
                    onClick={() => this.openLegend()}
                  />
                </div>
              )}
              {this.props.showLegendThresholdsForCertification && (
                <div className="legend-button">
                  <Button
                    text="app.button.legend"
                    onClick={() => this.openLegendThresholdsForCertification()}
                  />
                </div>
              )}
              {this.props.showLegendButton && (
                <div className="legend-button">
                  <Button
                    text="app.button.legend"
                    onClick={() => this.openLegendModal()}
                  />
                </div>
              )}
              {this.props.showTrafficButton && (
                <div className="traffic-button">
                  <Button
                    text={this.props.reportMode}
                    onClick={() => this.props.changeTrafficMode()}
                  />
                </div>
              )}
              {this.props.showPaperFreeAppButton && (
                <div
                  className={
                    config.applications.paperfree.length !== 0
                      ? "paperFree-button"
                      : "paperFree-button-invisible"
                  }
                >
                  <Button
                    text="app.button.paper-free"
                    onClick={() => this.openPaperFreeApp()}
                  />
                </div>
              )}
              {this.props.showChartButton && (
                <div className="chart-icon-button">
                  <Button
                    iconComponent={<Icons.Custom name="bar-chart" />}
                    text="app.report.graph"
                    onClick={() => this.openChartModal()}
                  />
                </div>
              )}
              {this.state.showChartModal && (
                <ChartModal
                  filteredData={
                    this.reactTableElement.getResolvedState().sortedData
                  }
                  rawData={data}
                  chartMeta={this.props.chartMeta}
                  closeChart={this.openChartModal}
                  closeOnOutsideClick
                />
              )}
              {this.state.showWarningAsyncReport && (
                <WarningAsyncReportModal
                  headerFormattedMessageId="app.warning.report.async.ready"
                  length={originalRowCount}
                  onCloseModal={this.closeWarningModal}
                />
              )}
              {this.props.modeTabs && (
                <div className="mode-tabs">
                  <ButtonTabs
                    tabs={modeTabs}
                    activeTab={mode}
                    onChange={changeMode}
                  />
                </div>
              )}
              <ReportCustomFilters type={this.props.customFilterType} />
              {isLoading && !isAsyncRequest && (
                <OnScreenModal
                  closeChart={this.openOnScreenModal}
                  reportId={reportId}
                  mainReportId={mainReportId}
                  {...this.props}
                >
                  closeOnOutsideClick
                </OnScreenModal>
              )}
              <div className="report-actions-tools">
                {!isLoading && generatedOnDateTime && (
                  <span className="generated-report__header__generated-on">
                    <FormattedMessage
                      id="app.report.generated.on"
                      values={{
                        date: generatedOn.date,
                        time: generatedOn.time,
                        totals: originalRowCount,
                      }}
                    />
                  </span>
                )}
                {this.props.currentReport &&
                  this.props.currentReport.showOnLaunchPage && (
                    <div className="report-action-button">
                      <Button
                        onClick={this.openSaveReportModal}
                        iconComponent={<Icons.SaveIcon />}
                        text="app.report.save"
                      />
                    </div>
                  )}
                {this.props.pdfButton && (
                  <div className="report-epg-management-pdf-button">
                    <Button
                      text="app.report.pdf"
                      onClick={() => {
                        this.exportPdf(
                          columns,
                          data,
                          reportId,
                          generatedOnDateTime,
                          this.reactTableElement.getResolvedState().sortedData,
                          totalRows
                        );
                      }}
                    />
                  </div>
                )}
                {data.length <= 300000 && (
                  <div className="report-action-download-button">
                    <div className="rdg">
                      <Button
                        iconComponent={<Icons.DownloadIcon />}
                        text="app.report.download"
                      />
                      <div className="download-menu">
                        <ul>
                          <li>
                            <div
                              className={`download-menu-item-excel ${excelDisabled}`}
                              onClick={this.openXlsExcelLoading}
                            >
                              Excel (Selection criteria + Report data)
                            </div>
                            <div className={`hover-text ${excelDisabled}`}>
                              Excel download is disabled for reports with more
                              than {this.state.maxRow} rows
                            </div>
                          </li>
                          <li>
                            <CSVLink
                              data={scData}
                              headers={headerSC}
                              filename={csvFileNameSC}
                              className="download-menu-item"
                            >
                              CSV (Selection criteria)
                            </CSVLink>
                          </li>
                          <li>
                            <CSVLink
                              data={formattedData}
                              headers={header}
                              filename={csvFileNameData}
                              className="download-menu-item"
                            >
                              CSV (Report data)
                            </CSVLink>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
                {data.length > 300000 && (
                  <div className="report-action-button">
                    <Button
                      onClick={this.openModal}
                      iconComponent={<Icons.DownloadIcon />}
                      text="app.report.download"
                    />
                  </div>
                )}
                <div className="report-action-button-switch">
                  <Button
                    onClick={
                      this.state.clipboard.clipboardEnabled
                        ? this.disableClipboard
                        : this.enableClipboard
                    }
                    iconComponent={<Icons.Clipboard />}
                    text="app.report.clipboard"
                    style={this.state.clipboard.clipboardButtonStyle}
                  />
                </div>
              </div>
            </div>
            {this.props.headerTitle && generatedOnDateTime && (
              <div className="report-epg-management">
                <div>{this.props.epgTitle}</div>
              </div>
            )}
            {hasTotalColumns && !this.state.clipboard.clipboardEnabled && (
              <div className="generated-report__table-wrapper totals-only">
                <ReactTable
                  ref={this.reactTableRef}
                  loading={isLoading}
                  loadingText={
                    isAsyncRequest ? "Processing request ..." : "Loading ..."
                  }
                  noDataText="No results for the current selection."
                  data={data}
                  columns={totalColumns}
                  expanded={false}
                  sortable={false}
                  filterable={false}
                  showPagination={false}
                  minRows={0}
                  getTrProps={getTrPropsFunc}
                  className={`report-table user-type-${userType.toLowerCase()}`}
                />
              </div>
            )}
            {hasColumns && (
              <div className="generated-report__table-wrapper">
                <ReactTable
                  ref={this.reactTableRef}
                  loading={isLoading}
                  loadingText={
                    isAsyncRequest ? "Processing request ..." : "Loading ..."
                  }
                  noDataText="No results for the current selection."
                  data={data}
                  columns={columnsTransformed}
                  sortable={this.state.sortingEnabled}
                  page={paginationMapper[this.props.reportId]}
                  onPageChange={(pageIndex) => this.changePage(pageIndex)}
                  onExpandedChange={(expanded) => this.setState({ expanded })}
                  onPageSizeChange={this.collapseAll}
                  onSortedChange={
                    this.state.sortingEnabled ? this.onSortedChange : noop
                  } // disable inherited sorting when sorting not enabled
                  onFilteredChange={
                    this.state.filteringEnabled ? this.onFilteredChange : noop
                  } // disable inherited filtering when filtering not enabled
                  expanded={this.state.expanded}
                  pageSizeOptions={[5, 15, 25, 50, 100]}
                  defaultPageSize={50}
                  minRows={0}
                  defaultSorted={defaultSorted}
                  getTrProps={getTrPropsFunc}
                  className={`report-table user-type-${userType.toLowerCase()}`}
                  // sorted={[]}
                  // eslint-disable-next-line arrow-body-style
                  getTdProps={(state, rowInfo, column, instance) => {
                    return !this.state.clipboard.clipboardEnabled
                      ? {}
                      : {
                          onClick: (e) => {
                            // override onClick to disable default actions
                          },
                          onDoubleClick: (e) => {
                            this.handleCellSelection(e, rowInfo, column);
                          },
                          style: {
                            background: this.isCellSelected(column, rowInfo)
                              ? TABLE_CELL_SELECTION_COLOR
                              : null,
                          },
                        };
                  }}
                  // eslint-disable-next-line arrow-body-style
                  getTheadThProps={(state, rowInfo, column) => {
                    return !this.state.clipboard.clipboardEnabled
                      ? {}
                      : {
                          onDoubleClick: (e) => {
                            this.handleColumnSelection(e, column);
                          },
                          style: {
                            background: this.isColumnSelected(column)
                              ? TABLE_COLUMN_SELECTION_COLOR
                              : null,
                          },
                        };
                  }}
                />
              </div>
            )}
            {reportId === "ITEM_OVERVIEW_DETAILS_200" && !hasColumns && (
              <div>
                <ItemOverviewDetails {...this.props} />
              </div>
            )}
            {this.props.showChart && (
              <ChartModal
                filteredData={
                  this.reactTableElement.getResolvedState().sortedData
                }
                rawData={data}
                chartMeta={this.props.chartMeta}
                closeChart={this.props.closeChart}
              />
            )}
            {this.state.showModal && (
              <XlsExportModal
                header={
                  <FormattedMessage
                    id="app.warning.download.limitation"
                    tagName="h5"
                  />
                }
                closeOnOutsideClick
                downloadReport={this.downloadReport}
                closeModal={this.openModal}
              />
            )}
            {this.state.showLoadingModal && (
              <XlsExportLoadingModal
                closeOnOutsideClick
                closeModal={this.closeXlsExcelLoading}
              />
            )}
            {this.state.showLabelModal && (
              <LegendModal closeChart={this.openLegendModal}>
                closeOnOutsideClick
              </LegendModal>
            )}
            {this.state.showLegendEpgModal && (
              <EpgLegendModal closeChart={this.openLegend}>
                closeOnOutsideClick
              </EpgLegendModal>
            )}
            {this.state.showLegendThresholdsForCertification && (
              <LegendModalThresholdsForCertification
                closeChart={this.openLegendThresholdsForCertification}
              >
                closeOnOutsideClick
              </LegendModalThresholdsForCertification>
            )}
            {this.state.showColorLegend && (
              <ColorLegendModal closeChart={this.openColorLegend}>
                closeOnOutsideClick
              </ColorLegendModal>
            )}
            {this.state.showSaveReportModal && (
              <SaveReportModal
                handleSubmit={this.saveReport}
                onCloseModal={this.closeSaveReportModal}
                currentReport={this.props.currentReport}
                headerFormattedMessageId="app.report.save.form.title"
              />
            )}
            {isLoading && !hasColumns && <span>Loading ...</span>}
          </section>
        )}
      </div>
    );
  }
}

Report.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  totalColumns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  modeTabs: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ),
  reportId: PropTypes.string,
  mode: PropTypes.string,
  changeMode: PropTypes.func,
  masterDetailsReport: PropTypes.instanceOf(MasterDetailsReport),
  showChart: PropTypes.bool,
  showTrafficButton: PropTypes.bool,
  showPaperFreeAppButton: PropTypes.bool,
  showLegend: PropTypes.bool,
  showColorLegend: PropTypes.bool,
  headerTitle: PropTypes.bool,
  pdfButton: PropTypes.bool,
  totalRows: PropTypes.arrayOf(PropTypes.object),
  epgTitle: PropTypes.string,
  showLegendEpgModal: PropTypes.bool,
  showLegendThresholdsForCertification: PropTypes.bool,
  showOnScreenModal: PropTypes.bool,
  showLegendButton: PropTypes.bool,
  showCollapseButton: PropTypes.bool,
  showChartButton: PropTypes.bool,
  chartMeta: PropTypes.objectOf(PropTypes.shape),
  closeChart: PropTypes.func,
  getTrProps: PropTypes.func,
  reportMode: PropTypes.string,
  changeTrafficMode: PropTypes.func,
  routePaperFreeApp: PropTypes.func,
  currentReport: PropTypes.objectOf(PropTypes.shape),
  requestParams: PropTypes.objectOf(PropTypes.shape),
  saveUserReportRequestActionCreator: PropTypes.func,
  isAsync: PropTypes.bool,
  isSync: PropTypes.bool,
  userType: PropTypes.string,
  customFilterType: PropTypes.string,
  tabsForceDataFetch: PropTypes.bool,
  selectionCriteria: PropTypes.objectOf(PropTypes.shape),
  onSortedChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
  filtering: PropTypes.object,
  sorting: PropTypes.object,
  defaultSorted: PropTypes.arrayOf(PropTypes.object),
  reporting: PropTypes.objectOf(PropTypes.shape),
  responseMode: PropTypes.string,
  isAsyncRequest: PropTypes.bool,
};

Report.defaultProps = {
  prepareData: (d) => d,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      saveUserReportRequestActionCreator,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  selectionCriteria: getSelectionCriteria(state),
  currentReport: getCurrentReport(state),
  requestParams: getRequestParams(state),
  userType: getUserType(state),
  isAsync: getIsAsync(state),
  isSync: getIsSync(state),
  filtering: getReportFiltering(state),
  sorting: getReportSorting(state),
  reporting: state.reporting,
  isAsyncRequest: getAsyncReq(state),
  responseMode: getResponseMode(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(Report);
